export enum AdTypes {
    SQUARE_AD = "square_ad",
    VERTICAL_AD = "vertical_ad",
    HORIZONTAL_AD = "horizontal_ad",
    TARGETED_HORIZONTAL_AD = "targeted_horizontal_ad"
}
